import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DashboardPage from "./pages/DashboardPage";
import UsersPage from "./pages/users/UsersPage";
import UserInvitation from "./pages/users/UsersInvitation";
import LoginPage from "./pages/auth/LoginPage";
import { GlobalContextProvider } from "./context/GlobalContext";
import LoadingComponent from "./components/utilities/LoadingComponent";
import LayoutMain from "./layout/LayoutMain";
import InboxPage from "./pages/inbox/InboxPage";
import UsersEdit from "./pages/users/UsersEdit";
import UsersEditPaidLeave from "./pages/users/UsersEditPaidLeave";
import UsersEditSalary from "./pages/users/UsersEditSalary";
import UsersEditSchedule from "./pages/users/UsersEditSchedule";
import AttendancePage from "./pages/attendance/AttendancePage";
import AttendanceCreate from "./pages/attendance/AttendanceCreate";
import AttendanceEdit from "./pages/attendance/AttendanceEdit";
import HolidayForm from "./pages/attendance/HolidayForm";
import ProtectedRoute from "./services/ProtectedRoute";
import ImportAttendance from "./pages/attendance/ImportAttendance";
import ScheduleForm from "./pages/attendance/ScheduleForm";
import ImportUsers from "./pages/users/ImportUsers";
import PayrollTemplateForm from "./pages/payroll/PayrollTemplateForm";
import PayrollPage from "./pages/payroll/PayrollPage";
import PayrollForm from "./pages/payroll/PayrollForm";
import SettingsPage from "./pages/settings/SettingsPage";
import { Helmet, HelmetProvider } from "react-helmet-async";
import NotFound from "./pages/NotFound";
import RegisterCompany from "./pages/register/RegisterCompany";
import OnBoarding from "./pages/auth/OnBoarding";
import RegisterPage from "./pages/auth/RegisterPage";
import VerifyEmailPage from "./pages/auth/VerifyEmailPage";
import VerifyInvitationPage from "./pages/auth/VerifyInvitationPage";
import ApprovalActionPage from "./pages/approvals/ApprovalActionPage";
import AnalyticsPage from "./pages/analytics/AnalyticsPage";
import LanguageKeyed from "./components/LanguageKeyed";

function App() {
  return (
    <HelmetProvider>
      <Helmet
        titleTemplate="%s | Sewoork HRIS System"
        defaultTitle="Sewoork HRIS"
      />
      <Router>
        <GlobalContextProvider>
          <LoadingComponent />
          <Routes>
            <Route path="/" exact element={<LoginPage />}></Route>
            <Route path="/login" exact element={<LoginPage />}></Route>
            {/* Not Found outside Layout */}
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route
              path="/verify-invitation"
              element={<VerifyInvitationPage />}
            />
            <Route path="/approval-action" element={<LanguageKeyed><ApprovalActionPage /></LanguageKeyed>} />
            <Route path="/get-started" element={<LanguageKeyed><RegisterCompany /></LanguageKeyed>} />
            <Route path="/get-started/*" element={<LanguageKeyed><RegisterCompany /></LanguageKeyed>} />

            <Route element={<ProtectedRoute />}>
              <Route path="/onboarding" element={<LanguageKeyed><OnBoarding /></LanguageKeyed>} />
              <Route path="/" element={<LayoutMain />}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/inbox" element={<InboxPage />} />

                {/* Users Routes */}
                <Route path="/users" element={<UsersPage />} />
                <Route path="/users/edit" element={<UsersEdit />} />
                <Route
                  path="/users/edit/paid-leave"
                  element={<UsersEditPaidLeave />}
                />
                <Route
                  path="/users/edit/salary"
                  element={<UsersEditSalary />}
                />
                <Route
                  path="/users/edit/schedule"
                  element={<UsersEditSchedule />}
                />
                <Route path="/users/new" element={<UserInvitation />} />
                <Route path="/users/import" element={<ImportUsers />} />

                {/* Attendance Routes */}
                <Route path="/attendance" element={<AttendancePage />} />
                <Route
                  path="/attendance/import"
                  element={<ImportAttendance />}
                />
                <Route path="/attendance/new" element={<AttendanceCreate />} />
                <Route path="/attendance/edit" element={<AttendanceEdit />} />

                {/* Holiday Routes */}
                <Route path="/holiday/form" element={<HolidayForm />} />

                {/* Schedules Routes */}
                <Route path="/schedules/form" element={<ScheduleForm />} />

                {/* Payroll Routes */}
                <Route path="/payroll" element={<PayrollPage />} />
                <Route path="/payroll/create" element={<PayrollForm />} />
                <Route path="/payroll/:id" element={<PayrollForm />} />
                <Route path="/payroll/form" element={<PayrollTemplateForm />} />

                {/* Analytics Routes */}
                <Route path="/analytics" element={<AnalyticsPage />} />

                {/* Settings Routes */}
                <Route path="/settings" element={<SettingsPage />} />
              </Route>
            </Route>

            {/* Not Found outside Layout */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </GlobalContextProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
